import { useState, useEffect } from 'react'
import { Link, useLocation } from 'react-router-dom'
import CTAButton from './CTAButton.jsx'

const NAV_LINKS = [
  { label: 'Fonctionnalités', to: '/fonctionnalites' },
  { label: 'Pour les profs',  to: '/pour-les-profs' },
  { label: 'Comparatif',      to: '/comparatif' },
  { label: 'Tarifs',          to: '/tarifs' },
  { label: 'FAQ',             to: '/faq' },
  { label: 'Blog',            to: '/blog' },
]

export default function Header() {
  const [menuOpen, setMenuOpen] = useState(false)
  const [scrolled, setScrolled]  = useState(false)
  const location = useLocation()

  useEffect(() => {
    const handler = () => setScrolled(window.scrollY > 8)
    window.addEventListener('scroll', handler, { passive: true })
    return () => window.removeEventListener('scroll', handler)
  }, [])

  useEffect(() => { setMenuOpen(false) }, [location])

  return (
    <header className={`sticky top-0 z-50 bg-white transition-shadow duration-200 ${scrolled ? 'shadow-md' : 'border-b border-slate-100'}`}>
      <div className="max-w-7xl mx-auto px-6 h-16 flex items-center justify-between gap-6">

        {/* Logo */}
        <Link to="/" className="flex items-center gap-2.5 shrink-0" aria-label="KartQuiz — accueil">
          <img src="/android-chrome-192x192.png" alt="KartQuiz" className="w-9 h-9 object-contain" />
          <span className="font-brand text-xl text-kart-night">KartQuiz</span>
        </Link>

        {/* Nav desktop */}
        <nav className="hidden md:flex items-center gap-1" aria-label="Navigation principale">
          {NAV_LINKS.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-2 rounded-lg text-sm font-medium transition-colors ${
                location.pathname === link.to
                  ? 'bg-kart-blue/10 text-kart-blue'
                  : 'text-slate-600 hover:text-kart-night hover:bg-slate-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
        </nav>

        {/* Actions desktop */}
        <div className="hidden md:flex items-center gap-3">
          <Link
            to="/home"
            className="text-sm font-medium text-slate-600 hover:text-kart-night transition-colors px-3 py-2"
          >
            Mon espace
          </Link>
          <CTAButton to="/login" size="sm">
            Créer un compte gratuit
          </CTAButton>
        </div>

        {/* Hamburger mobile */}
        <button
          onClick={() => setMenuOpen(v => !v)}
          className="md:hidden p-2 rounded-lg text-slate-600 hover:bg-slate-100 transition"
          aria-label={menuOpen ? 'Fermer le menu' : 'Ouvrir le menu'}
          aria-expanded={menuOpen}
        >
          {menuOpen ? (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            </svg>
          )}
        </button>
      </div>

      {/* Menu mobile */}
      {menuOpen && (
        <div className="md:hidden border-t border-slate-100 bg-white px-6 py-4 flex flex-col gap-1">
          {NAV_LINKS.map(link => (
            <Link
              key={link.to}
              to={link.to}
              className={`px-4 py-3 rounded-xl text-sm font-medium transition-colors ${
                location.pathname === link.to
                  ? 'bg-kart-blue/10 text-kart-blue'
                  : 'text-slate-600 hover:bg-slate-100'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <hr className="my-2 border-slate-100" />
          <Link
            to="/home"
            className="px-4 py-3 rounded-xl text-sm font-medium text-slate-600 hover:bg-slate-100"
          >
            Mon espace
          </Link>
          <CTAButton to="/login" size="sm" className="mt-1 w-full">
            Créer un compte gratuit
          </CTAButton>
        </div>
      )}
    </header>
  )
}
